import { motion } from "framer-motion";
import { Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { BIZ } from "@/data/business";
import { EASE } from "./motion";

export const TikTok = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.6 2.6 0 0 1-2.59-2.6 2.6 2.6 0 0 1 3.4-2.47V9.68a5.68 5.68 0 0 0-.81-.06A5.7 5.7 0 0 0 4.17 15.3 5.7 5.7 0 0 0 9.86 21a5.7 5.7 0 0 0 5.69-5.69V9.01a7.35 7.35 0 0 0 4.28 1.37V7.3a4.3 4.3 0 0 1-3.23-1.48Z" />
  </svg>
);

export const SOCIALS = [
  { id: "instagram", name: "Instagram", handle: BIZ.igHandle, url: BIZ.instagram, Icon: Instagram, tag: "Reels & before/afters" },
  { id: "tiktok", name: "TikTok", handle: BIZ.tiktokHandle, url: BIZ.tiktok, Icon: TikTok, tag: "Satisfying cleans" },
  { id: "facebook", name: "Facebook", handle: BIZ.facebookName, url: BIZ.facebook, Icon: Facebook, tag: "Updates & specials" },
];

export const Socials = () => (
  <section data-testid="socials-section" className="relative mx-auto max-w-[1440px] px-5 md:px-10 pb-24 md:pb-32">
    <div className="flex items-end justify-between gap-6 mb-8">
      <p className="eyebrow">Follow the shine</p>
      <p className="hidden sm:block font-mono text-xs text-slate-400 tracking-wider">New clips every week</p>
    </div>
    <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
      {SOCIALS.map((s, i) => (
        <motion.a key={s.id} href={s.url} target="_blank" rel="noreferrer" data-testid={`follow-${s.id}`}
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: EASE, delay: i * 0.08 }}
          className="group relative overflow-hidden bg-[#07080B] p-6 md:p-8 flex items-center gap-5">
          <span className="absolute inset-0 bg-[#1bb4f2] origin-bottom scale-y-0 group-hover:scale-y-100 transition-transform duration-500 ease-out" />
          <span className="relative h-14 w-14 shrink-0 grid place-items-center border border-white/15 group-hover:border-[#07080B]/20 group-hover:bg-[#07080B] text-[#1bb4f2] transition-colors">
            <s.Icon className="h-6 w-6" />
          </span>
          <span className="relative flex-1 min-w-0">
            <span className="block font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 group-hover:text-[#07080B]/70 transition-colors">{s.name} · {s.tag}</span>
            <span className="block mt-1 font-semibold text-white group-hover:text-[#07080B] break-all md:truncate transition-colors">{s.handle}</span>
          </span>
          <span className="relative shrink-0 inline-flex items-center gap-1 h-10 px-4 bg-white text-[#07080B] text-sm font-semibold group-hover:bg-[#07080B] group-hover:text-white transition-colors">
            Follow <ArrowUpRight className="h-4 w-4" />
          </span>
        </motion.a>
      ))}
    </div>
  </section>
);
